var FileUploaderContentMode;
(function (FileUploaderContentMode) {
    FileUploaderContentMode["CONTEXTUAL_BAR_WRAPPER"] = "contextual-bar-wrapper";
    FileUploaderContentMode["MODAL_WRAPPER"] = "modal-wrapper";
    FileUploaderContentMode["NO_WRAPPER"] = "no-wrapper";
})(FileUploaderContentMode || (FileUploaderContentMode = {}));
export { FileUploaderContentMode, };
//# sourceMappingURL=file-uploader-content-types.js.map